import {ShapeComponent, shapeComponent} from "set-state-compare/src/shape-component"
import memo from "set-state-compare/src/memo"
import React from "react"
import Route from "@kaspernj/api-maker/build/router/route"
import Switch from "@kaspernj/api-maker/build/router/switch"
import {useWoofRouter} from "shared/woof-router"
export default memo(shapeComponent(class RoutesAdminSchoolClassesRoute extends ShapeComponent {
  setup() {
    this.woofRouter = useWoofRouter()
  }

  render() {
    return (
      <Switch name="school-classes">
        <Route component="edit" exact path="new" />
        <Route exact path=":school_class_id/audits" />
        <Route component="school-class-roles" exact path=":school_class_id/school_class_roles" />
        <Route exact path=":school_class_id/subscriptions" />
        <Route component="unicorn-effects" exact path=":school_class_id/unicorn_effects" />
        <Route exact path=":school_class_id/edit" />
        <Route component="show" exact path=":school_class_id" />
        <Route component="index" exact />
        <Route componentPath="fallback" fallback onMatch={this.tt.onFallbackMatch} />
      </Switch>
    )
  }

  onFallbackMatch = () => this.woofRouter.setPageNotFound(true)
}))
